import { useReveal } from "@/lib/useReveal";

const STEPS = [
  {
    n: "01",
    title: "Search",
    body: "We cross-check public records, court dockets and county registers to confirm surplus funds exist in your name.",
  },
  {
    n: "02",
    title: "Verify",
    body: "We authenticate your identity, ownership and lawful right to claim — no guesswork, no shortcuts.",
  },
  {
    n: "03",
    title: "Recover",
    body: "Our team files every petition, motion, and supporting document with the holding county or court.",
  },
  {
    n: "04",
    title: "Receive",
    body: "Funds are released directly to you. Our fee is paid only on success — you owe nothing if we don't recover.",
  },
];

export const HowItWorks = () => {
  const ref = useReveal();
  return (
    <section
      id="process"
      data-testid="process-section"
      ref={ref}
      className="bg-[#F3F0E6] py-24 sm:py-32 relative"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-2xl mb-20 reveal">
          <div className="flex items-center gap-3 mb-6">
            <span className="h-px w-10 bg-[#D4AF37]" />
            <span className="text-[#1E3A5F] text-xs uppercase tracking-[0.3em]">
              Our Process
            </span>
          </div>
          <h2 className="font-serif-display text-[#0A192F] text-4xl sm:text-5xl lg:text-6xl font-medium leading-[1.05]">
            Four steps.
            <br />
            <em className="italic text-[#1E3A5F]">Zero risk to you.</em>
          </h2>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-px bg-[#E2DCD0]">
          {STEPS.map((s, i) => (
            <div
              key={s.n}
              data-testid={`process-step-${i + 1}`}
              className="reveal bg-[#FDFBF7] p-10 hover:bg-[#FDFBF7] transition-colors group"
              style={{ transitionDelay: `${i * 100}ms` }}
            >
              <div className="font-serif-display text-[#D4AF37] text-5xl mb-8 group-hover:translate-y-[-4px] transition-transform">
                {s.n}
              </div>
              <h3 className="font-serif-display text-[#0A192F] text-3xl mb-4">
                {s.title}
              </h3>
              <p className="text-[#1E3A5F] leading-relaxed text-sm">
                {s.body}
              </p>
            </div>
          ))}
        </div>

        <p className="mt-12 text-center text-sm text-[#1E3A5F]">
          <span className="font-semibold text-[#0A192F]">No win, no fee.</span>{" "}
          You pay nothing unless we successfully recover your funds.
        </p>
      </div>
    </section>
  );
};
